// extracted by mini-css-extract-plugin
module.exports = {"statbody":"Statistics_statbody__ey_JK","tableS":"Statistics_tableS__3PuP0","tabtab":"Statistics_tabtab__3MIGh","table_wrapper":"Statistics_table_wrapper__1vIUH"};